import React from 'react';
import AuthService from './authService.js';

export default class OfficeBridgeDayService extends React.Component {
  static Get(officeId, year) {
    const authService = AuthService.getInstance();
    const url = `/api/OfficeBridgeDay/Get?officeId=${officeId}&year=${year}&clearCache=true`;
    return authService.CallBackendFunction(url);
  }

  static Save(item) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost('/api/OfficeBridgeDay/Save', JSON.stringify(item));
  }

  static Delete(id) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(`/api/OfficeBridgeDay/Delete?id=${id}`, JSON.stringify({}));
  }

  static SetSkipped(item) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost('/api/OfficeBridgeDay/SetSkipped', JSON.stringify(item));
  }
}
